import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { dangerService } from '../../dangerService'
import { ISearchPage } from '@/types/AppTypes'
import { DangerTabType } from '../../dangerModel'

export const vehicleDetialModel = createModel(function () {
    //查看详情form
    const [detailLookList, setDetailLookList] = useState<any>([])
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const getOne = async (page: ISearchPage = pgCfgRef.current, id, dangerTab: DangerTabType = 'scheduling') => {
        const searchParams = {
            hiddenDangerId: id,
        }
        const isInspectionTab = dangerTab === 'inspection'
        const res = isInspectionTab ? await dangerService.inspectionOne(searchParams) : await dangerService.one(searchParams)
        const { retData } = res
        const { circulationLogPageVoList, schedulingItemImgList } = retData
        let driverPic = schedulingItemImgList.filter((list) => list.type === 'hidden.danger').map((item) => item.md5)
        let technicianPic = schedulingItemImgList.filter((list) => list.type === 'main.diagram').map((item) => item.md5)
        let adminTechnicianPic = schedulingItemImgList.filter((list) => list.type === 'admin.main.diagram').map((item) => item.md5)
        let logsList = circulationLogPageVoList.map((item) => {
            return {
                ...item,
                driverPic: driverPic,
                technicianPic: technicianPic,
                adminTechnicianPic: adminTechnicianPic,
            }
        })
        setDetailLookList(logsList)
    }

    return {
        /***field***/
        initPgCfg,
        selectedRowKeys,
        pgCfg,
        detailLookList,
        /***method***/
        setDetailLookList,
        setSelectedRowKeys,
        getOne,
        setPgCfg,
    }
})
